<template>
  <div class="c-slider-button">
    <div class="c-slider-button__left" @click="$emit('clickleft')">
      <o-icon class="c-slider-button__icon" :icon="iconLeft" v-if="iconLeft" />
      <div class="c-slider-button__label">{{ labelLeft }}</div>
    </div>
    <div class="c-slider-button__right" @click="$emit('clickright')">
      <div class="c-slider-button__label">{{ labelRight }}</div>
      <o-icon class="c-slider-button__icon" :icon="iconRight" v-if="iconLeft" />
    </div>
    <div class="c-slider-button__knob">
      <o-icon icon="arrow-left-right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliderButton',
  props: {
    labelLeft: String,
    iconLeft: String,
    labelRight: String,
    iconRight: String
  }
}
</script>

<style lang="scss">
.c-slider-button {
  background: $background-color;
  border: 0.1rem solid rgba(#000, 0.1);
  border-radius: 2.4rem;
  display: flex;
  height: 4.8rem;
  position: relative;
}

.c-slider-button__left,
.c-slider-button__right {
  align-items: center;
  color: $primary-color;
  coloor: var(--primary-color);
  display: flex;
  font-size: 1.6rem;
  font-weight: 600;
  padding: 1.2rem;

  & > * + * {
    margin-left: 0.8rem;
  }
}

.c-slider-button__left {
}

.c-slider-button__right {
  margin-left: auto;
}

.c-slider-button__knob {
  background: $primary-color;
  background: var(--primary-color);
  border-radius: 2.4rem;
  color: #fff;
  display: flex;
  height: 4.8rem;
  left: calc(50% - 2.4rem);
  position: absolute;
  width: 4.8rem;

  & > * {
    margin: auto;
  }
}
</style>
